import React, { memo } from 'react';
import { withStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import PF2MTooltip from '~/components/PF2MTooltip';
import EquipmentItem from '../EquipmentItem';
import EquipmentStatusCounter from '../EquipmentStatusCounter';
import styles from './styles';

const HIGHLIGHT_DURATION = 5000;

const EquipmentGroupList = memo(({
  list,
  isFullScreenActive,
  highlightedEquipments,
  classes,
}) => {
  const isEquipmentHighlighted = (id_equip) => {
    const highlightTime = highlightedEquipments[id_equip];
    return highlightTime && (Date.now() - highlightTime < HIGHLIGHT_DURATION);
  };

  return (
    <div className={classes.containerWrapperEquipGroupList}>
      {list.map((equipGroup, index) => (
        <div
          className={classes.wrapperEquipGroupStatus}
          key={equipGroup.equip_group_id}
        >
          <div
            className={classNames(
              classes.containerEquipGroup,
              index === 0 && classes.firstGroup,
            )}
          >
            <div className={classes.wrapperLabelGroup}>
              <div className={classes.boxLabelGroup}>
                <PF2MTooltip
                  title={equipGroup?.label}
                  PopperProps={{
                    container: isFullScreenActive && document.fullscreenElement
                      ? document.fullscreenElement
                      : document.body,
                  }}
                >
                  <span className={classes.labelGroup}>{equipGroup?.label || ''}</span>
                </PF2MTooltip>
              </div>
            </div>
            <div className={classes.boxEquipItem}>
              {equipGroup.list.map(equip => (
                <EquipmentItem
                  key={`${equip.id_equip}-${highlightedEquipments?.[equip.id_equip] || 0}`}
                  equip={equip}
                  isHighlighted={isEquipmentHighlighted(equip?.id_equip)}
                />
              ))}
            </div>
          </div>
          <EquipmentStatusCounter counter={equipGroup.counter} />
        </div>
      ))}
    </div>
  );
});

export default withStyles(styles)(EquipmentGroupList);

EquipmentGroupList.propTypes = {
  classes: PropTypes.object.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      equip_group_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string,
      list: PropTypes.array.isRequired,
      counter: PropTypes.object.isRequired,
    }),
  ).isRequired,
  isFullScreenActive: PropTypes.bool,
  highlightedEquipments: PropTypes.objectOf(PropTypes.number),
};

EquipmentGroupList.defaultProps = {
  isFullScreenActive: false,
  highlightedEquipments: {},
};
